import { createSelector } from '@ngrx/store';
import { cartState } from '../root';

export const getCartPickupTime = createSelector(cartState, (cart) => cart.pickupTime);
